import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { IMAGES } from "@/lib/site";

export const CTABanner = ({ sideImage }) => {
  return (
    <section data-testid="cta-banner" className="py-20 md:py-28">
      <div
        data-testid="cta-full-bleed-tile"
        className="relative min-h-[520px] overflow-hidden px-0 py-16 md:min-h-[560px] md:py-20"
      >
        <img
          src="/media/core-banking-services.webp"
          alt=""
          aria-hidden="true"
          className="absolute inset-0 h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(11,31,58,0.96), rgba(11,31,58,0.84), rgba(11,31,58,0.34))" }} />
        <div className="absolute inset-0 bg-grid opacity-20" />
        <div className="relative z-10 mx-auto max-w-7xl px-6 lg:px-12">
          <div className={sideImage ? "grid gap-10 lg:grid-cols-2 lg:items-center" : "max-w-3xl"}>
            <div className={sideImage ? "max-w-xl" : ""}>
              <p className="section-eyebrow conversation-label text-sm uppercase tracking-[0.15em] font-semibold text-white/90">
                Start the conversation
              </p>
              <h2 className="mt-4 text-3xl md:text-5xl font-bold text-white tracking-tight leading-[1.1]">
                Ready to modernize your Core Banking platform?
              </h2>
              <p className="mt-5 text-lg text-white/90 leading-relaxed">
                Talk to a core banking specialist about your architecture,
                migration or modernization goals. No obligation — just expert guidance.
              </p>
              <div className="mt-8">
                <Link to="/contact" data-testid="cta-contact-button">
                  <Button className="rounded-[var(--radius-button)] bg-white text-brand hover:bg-white/95 font-semibold gap-2 px-7 h-12 text-base w-full sm:w-auto shadow-lg">
                    Contact Us <ArrowRight className="w-4 h-4" />
                  </Button>
                </Link>
              </div>
            </div>
            {sideImage && (
              <div className="relative">
                <img
                  src={sideImage}
                  alt="Sphere IT Solutions consultants discussing a core banking programme"
                  className="w-full aspect-[16/9] rounded-[var(--radius-card)] object-cover ring-1 ring-white/30 shadow-[var(--shadow-card)]"
                  loading="lazy"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABanner;
